import { api } from "./_client";

export async function listEmailProviders() {
    const { data } = await api.get("/email/providers");
    return data?.providers || [];
}

export async function listEmailAccounts() {
    const { data } = await api.get("/email/accounts");
    return data || [];
}

export async function addEmailAccount(payload) {
    const { data } = await api.post("/email/accounts", payload);
    return data;
}

export async function oauthMicrosoftStart() {
    const { data } = await api.get("/oauth/microsoft/start");
    return data?.authorize_url || "";
}

export async function deleteEmailAccount(id) {
    const { data } = await api.delete(`/email/accounts/${id}`);
    return data;
}

export async function updateEmailSignature(id, patch) {
    const { data } = await api.patch(`/email/accounts/${id}/signature`, patch);
    return data;
}

export async function listEmailMessages(accountId, folder = "INBOX", limit = 50, query = "") {
    const qp = new URLSearchParams({ folder, limit: String(limit) });
    if (query) qp.set("q", query);
    const { data } = await api.get(
        `/email/accounts/${accountId}/messages?${qp.toString()}`,
    );
    return data; // { messages, folder, count, query }
}

// iter-110: cross-account customer-conversation search. Used by the
// "Recent emails from this customer" panel in the project edit dialog.
export async function searchEmailsByAddress(address, limit = 10) {
    const qp = new URLSearchParams({ address, limit: String(limit) });
    const { data } = await api.get(`/email/search-by-address?${qp.toString()}`);
    return data; // { messages: [{...row, _account_id, _account_email, _folder}], address, count }
}

export async function getEmailMessage(accountId, uid, folder = "INBOX", markSeen = true) {
    const { data } = await api.get(
        `/email/accounts/${accountId}/messages/${encodeURIComponent(uid)}` +
        `?folder=${encodeURIComponent(folder)}&mark_seen=${markSeen}`,
    );
    return data;
}

export async function emailAttachmentUrl(accountId, uid, idx, folder = "INBOX") {
    // Returns a blob URL for download (token in header)
    const r = await api.get(
        `/email/accounts/${accountId}/messages/${encodeURIComponent(uid)}/attachments/${idx}` +
        `?folder=${encodeURIComponent(folder)}`,
        { responseType: "blob" },
    );
    return URL.createObjectURL(r.data);
}

export async function flagEmailMessage(accountId, uid, folder, seen) {
    const { data } = await api.post(
        `/email/accounts/${accountId}/messages/${encodeURIComponent(uid)}/flag?folder=${encodeURIComponent(folder)}`,
        { seen },
    );
    return data;
}

export async function deleteEmailMessage(accountId, uid, folder) {
    const { data } = await api.delete(
        `/email/accounts/${accountId}/messages/${encodeURIComponent(uid)}` +
        `?folder=${encodeURIComponent(folder)}`,
    );
    return data;
}

export async function sendEmail(accountId, payload, files = [], onProgress = null) {
    const form = new FormData();
    form.append("payload", JSON.stringify(payload));
    for (const f of files || []) form.append("files", f);
    const { data } = await api.post(
        `/email/accounts/${accountId}/send`,
        form,
        {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (e) => {
                if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
            },
        },
    );
    return data;
}

// Fetch the PDF bytes for a given estimate. quote_data shape is the
// same normalised payload QuoteView.jsx renders on screen.

export async function updateEmailScanConfig(accountId, patch) {
    const { data } = await api.patch(
        `/email/accounts/${accountId}/scan-config`,
        patch,
    );
    return data;
}

export async function scanEmailAccountNow(accountId) {
    const { data } = await api.post(
        `/email/accounts/${accountId}/scan-now`,
    );
    return data;
}

// ============================================================
// iter-95: credit packs (one-time top-ups) + promo codes
// ============================================================
